import type { GlobalApiAccountAccess } from '@data/account-access';
import type { GlobalApiPaymentDetails } from '@data/global-api-payments';

import { getFlow } from '../getFlow/getFlow';

export function getSCAMethods(
  subject: GlobalApiAccountAccess | GlobalApiPaymentDetails | null | undefined
) {
  if (!subject) {
    return null;
  }

  const flow = getFlow(subject);

  if (!('requiredInput' in flow)) {
    return null;
  }

  const [scaMethods] = flow.requiredInput.filter(
    (input) => input.name === 'SCA_METHOD'
  );

  if (!scaMethods) {
    return null;
  }

  if (scaMethods.name !== 'SCA_METHOD') {
    return null;
  }

  if (!('allowedValues' in scaMethods)) {
    return null;
  }

  return scaMethods;
}
